import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";

const Container = styled.div`
  position: relative;
  overscroll-behavior: none;
  height: 100%;
  width: 100%;

  overflow-y: auto;
  overflow-x: auto;
`;

const VerticalShadowWrapper = styled.div`
  opacity: 0;
  pointer-events: none;
  position: absolute;
  transition: opacity 300ms;
  box-shadow: rgb(0, 0, 0, 0.6) 0px 0px 20px 3px;
`;

const TopShadow = styled(VerticalShadowWrapper)`
  top: 0;
`;

const BottomShadow = styled(VerticalShadowWrapper)`
  bottom: 0;
  transform: rotate(180deg);
`;

const HorizontalShadowWrapper = styled.div`
  opacity: 0;
  position: absolute;
  top: 0;
  bottom: 0;
  pointer-events: none;
  height: 100%;
  width: 20px;
`;

const LeftShadow = styled(HorizontalShadowWrapper)`
  left: 0;
  background: linear-gradient(to right, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0));
`;

const RightShadow = styled(HorizontalShadowWrapper)`
  right: 0;
  background: linear-gradient(to left, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0));
`;

type Props = {
  style?: React.CSSProperties;
  maxHeight?: number;
};

export const ScrollShadowWrapper: React.FC<Props> = ({ children, style, maxHeight }) => {
  const containerRef = useRef<HTMLDivElement>(null);

  const [scrollTop, setScrollTop] = useState(0);

  const [scrollHeight, setScrollHeight] = useState(0);

  const [clientHeight, setClientHeight] = useState(0);

  const [scrollLeft, setScrollLeft] = useState(0);

  const [scrollWidth, setScrollWidth] = useState(0);

  const [clientWidth, setClientWidth] = useState(0);

  useEffect(() => {
    if (!containerRef.current) {
      return;
    }

    onScroll(containerRef.current);
  }, [containerRef?.current?.clientHeight]);

  const onScroll = (target: HTMLDivElement) => {
    setScrollTop(Math.ceil(target.scrollTop));

    setScrollHeight(target.scrollHeight);

    setClientHeight(target.clientHeight);

    setScrollLeft(Math.ceil(target.scrollLeft));

    setScrollWidth(target.scrollWidth);

    setClientWidth(target.clientWidth);
  };

  const scrollPercents = {
    vertical: scrollTop / (scrollHeight - clientHeight),
    horizontal: scrollLeft / (scrollWidth - clientWidth),
  };

  return (
    <div
      style={{ ...style, overflow: "hidden", position: "relative", height: "100%", width: "100%" }}
    >
      <Container
        ref={containerRef}
        onScroll={event => onScroll(event.currentTarget)}
        style={{ maxHeight }}
      >
        {children}
      </Container>

      <TopShadow
        style={{
          opacity: isNaN(scrollPercents.vertical) ? 0 : scrollPercents.vertical,
          width: containerRef.current?.scrollWidth,
        }}
      />

      <BottomShadow
        style={{
          opacity: isNaN(scrollPercents.vertical) ? 0 : 1 - scrollPercents.vertical,
          width: containerRef.current?.scrollWidth,
        }}
      />

      <LeftShadow
        style={{
          opacity: isNaN(scrollPercents.horizontal) ? 0 : scrollPercents.horizontal,
        }}
      />

      <RightShadow
        style={{
          opacity: isNaN(scrollPercents.horizontal) ? 0 : 1 - scrollPercents.horizontal,
        }}
      />
    </div>
  );
};
